import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  @Input() message = '';
  @Input() value: string | undefined = '';
  @Input() loading$ = new BehaviorSubject<boolean>(true);
  @Input() hasObservable = false;
  @Output() closeRequest = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}
}
